module.exports = "<hr class=\"hr-text\" [attr.data-content]=\"titleDivider\" [ngClass]=\"white?'white':null\">\n\n"